export class RoleUser {
  id: number;
  key: string;
}
